<template>
  <div>
    <div
      style="
        position: fixed;
        top: 20px;
        z-index: 10;
        backdrop-filter: blur(2px);
      "
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>

    <div class="main-container">
      <div class="dashboardAdmin-header d-flex align-items-center">
        <img
          src="../../assets/img/feedbackform/backarrow.svg"
          class="pointer"
          @click="gobackpointer"
          alt=""
        />
        <div class="dashboardAdmin-header-main-head ml-2">
          <span>
            {{
              $route.name === "EditFeedbackform"
                ? "Edit"
                : $route.name === "ActivateFeedbackForm"
                ? "Activate"
                : "Create"
            }}
            Feedback Form
          </span>
        </div>
      </div>
      <div class="pff-add-container mt-3 py-3 px-3 d-flex">
        <div class="w-40 pl-3 h-100">
          <div class="overflow-auto pr-1">
            <div class="pff-add-left-main-headings">
              Feedback Form Name<span class="asterik">*</span>
            </div>
            <div class="position-relative">
              <b-form-input
                class="inputField"
                id="input-1"
                placeholder="Enter Here"
                v-model="$v.feedbackData.name.$model"
                :class="{ error: $v.feedbackData.name.$error }"
              >
              </b-form-input>
              <div
                class="newInt-required-validation-font mt-1"
                v-if="
                  $v.feedbackData.name.$dirty && !$v.feedbackData.name.required
                "
              >
                Required
              </div>
              <div
                class="newInt-required-validation-font mt-1"
                v-if="
                  !$v.feedbackData.name.maxLength &&
                  $v.feedbackData.name.required
                "
              >
                Should not exceed 128 characters
              </div>
              <div
                class="newInt-required-validation-font mt-1"
                v-if="
                  !$v.feedbackData.name.alpha && $v.feedbackData.name.required
                "
              >
                Please Enter a Valid Name
              </div>
            </div>
            <div class="mt-4">
              <!-- <div class="pff-add-left-main-headings">
                Candidate Screenshot
                <span class="pff-add-left-main-subtext">
                  (Panelist should attach screenshot of the interview)</span
                >
              </div>
              <div class="d-flex new-center-radio">
                <b-form-radio-group
                  class="radio-class mt-3"
                  v-model="feedbackData.screenshot"
                  :options="Screenshots"
                  value-field="value"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-radio-group>
              </div> -->
            </div>
            <div class="mt-4 new-center-radio">
              <div class="d-flex align-items-center">
                <div class="pff-add-left-main-headings">
                  Skill Evaluation<span
                    v-if="feedbackData.skillratings.length === 0"
                    class="asterik"
                    >*</span
                  >
                </div>
                <div class="error-txt-tc ml-2" v-if="skillEval">
                  <img
                    src="../../assets/img/feedbackform/error-skill-eval.svg"
                    alt=""
                  />

                  <span class="ml-1">Required</span>
                </div>
              </div>
              <b-form-radio-group
                class="radio-class mt-2"
                :options="options"
                value-field="value"
                text-field="name"
                disabled-field="notEnabled"
                @change="(discard = true), checkSkillEval()"
                v-model="skillrating.markingType"
              ></b-form-radio-group>
            </div>
            <hr class="mt-4" />
            <div class="position-relative mt-2">
              <div class="pff-add-left-main-headings">
                Skill Name<span
                  v-if="feedbackData.skillratings.length === 0"
                  class="asterik"
                  >*</span
                >
              </div>
              <b-form-input
                class="inputField"
                :class="
                  errorsameskill || $v.skillrating.name.$error ? 'error' : ''
                "
                id="input-1"
                placeholder="Enter Skill Name"
                v-model.trim="$v.skillrating.name.$model"
              >
              </b-form-input>
              <div
                class="newInt-required-validation-font mt-1"
                v-if="
                  $v.skillrating.name.$dirty && !$v.skillrating.name.required
                "
              >
                Required
              </div>

              <div
                class="newInt-required-validation-font mt-1"
                v-if="errorsameskill"
              >
                Skill Name already exists
              </div>
              <div
                class="newInt-required-validation-font mt-1"
                v-if="!$v.skillrating.name.maxLength"
              >
                Should not exceed 128 characters
              </div>
            </div>

            <div class="mt-4 pff-checkbox">
              <b-form-checkbox
                id="comments-checkbox"
                v-model="skillrating.commentMode"
                name="comments-checkbox"
                class="radio-class feed-checkbox-alignment"
                :value="true"
                @change="(discard = true), checkSkillEval()"
                :unchecked-value="false"
                >Comments
              </b-form-checkbox>
              <div class="ml-4 pff-comments-subtext">
                User will be able to add descriptive response
              </div>
            </div>
            <div class="mt-3 pff-checkbox">
              <b-form-checkbox
                id="required-checkbox"
                name="required-checkbox"
                v-model="skillrating.mandatory"
                @change="discard = true"
                :value="true"
                :unchecked-value="false"
                class="radio-class feed-checkbox-alignment"
                >Mandatory
              </b-form-checkbox>
              <div class="ml-4 pff-comments-subtext">
                Set the field to be mandatory or optional
              </div>
            </div>
          </div>
          <div
            class="mt-4 d-flex align-items-center"
            :class="
              editskill ? 'justify-content-between' : 'justify-content-end'
            "
          >
            <div
              class="pointer pff-btn-txt"
              v-if="editskill"
              @click="resetSelectedSkill()"
            >
              Cancel
            </div>
            <div class="d-flex align-items-center">
              <div
                class="pointer"
                :class="{
                  'pff-btn-disable-btntxt':
                    (editskill && !discard) || skillrating.name == '',
                  'pff-btn-txt':
                    !editskill || discard || skillrating.name != '',
                }"
                @click="
                  (editskill && !discard) || skillrating.name == ''
                    ? ''
                    : editOrUpdateOrDeleteSkill('discard', '')
                "
              >
                Discard
              </div>
              <div class="pff-btn-divider mx-3"></div>
              <div
                v-if="!editskill"
                :class="
                  isdisable || errorsameskill
                    ? 'pff-btn-disable-btntxt'
                    : 'pff-btn-txt'
                "
                class="pff-btn-txt pointer"
                @click="isdisable || errorsameskill ? '' : addskill()"
              >
                Add
              </div>
              <div
                v-else
                :class="
                  isdisable || errorsameskill
                    ? 'pff-btn-disable-btntxt'
                    : 'pff-btn-txt'
                "
                class="pff-btn-txt pointer"
                @click="
                  isdisable || errorsameskill
                    ? ''
                    : editOrUpdateOrDeleteSkill('update')
                "
              >
                Update
              </div>
            </div>
          </div>
        </div>
        <div class="w-60 pff-add-right-container ml-3 p-3" id="scrollTobottom">
          <!-- v-if="feedbackData.skillratings.length" -->
          <div :class="!shimmerLoader ? 'd-flex justify-content-between' : ''">
            <div v-if="shimmerLoader">
              <b-skeleton class="w-35"></b-skeleton>
            </div>
            <div class="pff-right-heading" v-else>
              Feedback Form
              <img
                v-if="
                  aiLength !== 0 &&
                  $route.name == 'Feedbackform' &&
                  !aiEditSkill
                "
                src="../../assets/New-imgs/interviewProcess-icons/ai-button.svg"
                alt=""
              />
            </div>
            <div
              @click="$bvModal.show('newpreviewFeedback')"
              class="pointer"
              v-if="!shimmerLoader"
            >
              <img src="../../assets/talentpool/blueEye.svg" alt="" />
              <span class="newInt-preview-font ml-1">Preview</span>
            </div>
          </div>
          <!-- <div
            class="
              d-flex
              align-items-center
              justify-content-center
              flex-column
              h-90
            "
            v-if="
              feedbackData.skillratings.length == 0 
            "
          >
            <img
              src="../../assets/img/feedbackform/pd-right-empty.svg"
              alt=""
            />
            <div class="pff-right-emptytxt mt-3">
              Please add fields from the left side panel to create a feedback
              <br />
              form
            </div>
          </div> -->

          <div class="w-100 mt-3">
            <draggable v-model="feedbackData.skillratings">
              <template>
                <div v-if="shimmerLoader">
                  <div
                    class="pff-right-content-cards mb-2"
                    v-for="i in loop"
                    :key="i"
                  >
                    <b-skeleton class="mt-2 w-35"></b-skeleton>
                    <b-skeleton class="mt-2 w-50"></b-skeleton>
                    <b-skeleton class="mt-2 h-55"></b-skeleton>
                  </div>
                </div>
                <div
                  v-else
                  class="d-flex justify-content-between mt-2"
                  v-for="(skill, index) in feedbackData.skillratings"
                  :key="skill.id"
                >
                  <div class="mt-4 pointer">
                    <img
                      src="../../assets/img/feedbackform/drag-and-drop.svg"
                      alt=""
                    />
                  </div>
                  <div
                    :class="{
                      'pff-right-selected-content-cards mb-2 pointer':
                        feedbackData.skillratings[index].editskill,
                      ' pff-right-selected-content-cards  mb-2 pointer':
                        feedbackData.skillratings[index].markingType ===
                          'rating' &&
                        feedbackData.skillratings[index].editskill,
                      'pff-right-content-cards mb-2':
                        !feedbackData.skillratings[index].editskill,
                    }"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="pff-right-card-main-txt text-truncate w-60">
                        {{ skill.name }}
                        <span v-if="skill.mandatory == true" class="asterik"
                          >*</span
                        >
                      </div>
                      <div>
                        <div class="d-flex" style="width: 25%">
                          <div
                            :class="
                              feedbackData.skillratings[index].editskill
                                ? 'pff-disable-card-icon-container'
                                : 'pff-card-icon-container pointer'
                            "
                            class="pff-card-icon-container mr-2"
                            @click="
                              !skill.editskill
                                ? editOrUpdateOrDeleteSkill('edit', skill)
                                : ''
                            "
                          >
                            <img
                              v-b-tooltip.hover.top="
                                !feedbackData.skillratings[index].editskill
                                  ? 'Edit'
                                  : ''
                              "
                              src="../../assets/img/feedbackform/pd-right-edit.svg"
                              alt=""
                            />
                          </div>

                          <div
                            :class="
                              feedbackData.skillratings[index].editskill ||
                              feedbackData.skillratings.length === 1
                                ? 'pff-disable-card-icon-container'
                                : 'pff-card-icon-container pointer'
                            "
                          >
                            <img
                              @click="
                                !feedbackData.skillratings[index].editskill &&
                                feedbackData.skillratings.length > 1
                                  ? editOrUpdateOrDeleteSkill('delete', index)
                                  : ''
                              "
                              v-b-tooltip.hover.top="
                                !feedbackData.skillratings[index].editskill &&
                                feedbackData.skillratings.length > 1
                                  ? 'Delete'
                                  : ''
                              "
                              :class="
                                feedbackData.skillratings[index].editskill ||
                                feedbackData.skillratings.length === 1
                                  ? 'ip-opacity'
                                  : 'pointer'
                              "
                              src="../../assets//img/feedbackform/pd-right-delete.svg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="skill.markingType === 'rating'"
                      class="pff-rating d-flex align-items-center mt-1 mb-2"
                    >
                      <div class="pff-right-card-subheads">Rating</div>
                      <b-form-rating
                        variant="primary"
                        v-model="skill.mark"
                        disabled
                        class="scorerate w-15 newInt-rating"
                      ></b-form-rating>
                    </div>
                    <div
                      v-if="skill.markingType === 'score'"
                      class="d-flex align-items-center mt-1"
                    >
                      <div class="pff-right-card-subheads">Score</div>
                      <div class="topDiv ml-1 w-30px h23px">
                        <b-form-input
                          class="modaldisableinputField w-100 h-100"
                          id="input-1"
                          v-model="skill.mark"
                          type="number"
                          disabled
                        >
                        </b-form-input>
                      </div>
                      <div class="pff-right-card-subheads ml-1">out of 10</div>
                    </div>
                    <div v-if="skill.commentMode === true">
                      <div class="pff-right-card-subheads mt-1">Comments</div>
                      <div class="topDiv mt-1">
                        <b-form-textarea
                          class="modaldisableinputField"
                          rows="2"
                          type="text"
                          placeholder="Comments will be shown here"
                          max-rows="5"
                          v-model="skill.comments"
                          disabled
                        >
                        </b-form-textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
            <!-- <div class="d-flex justify-content-between">
              <div></div>
              <div
                class="pff-right-content-cards mt-2"
                v-if="feedbackData.screenshot"
              >
                <div class="pff-right-card-main-txt">
                  Candidate Screenshot<span class="asterik">*</span>
                </div>
                <div class="d-flex justify-content-center w-100">
                  <div
                    class="
                      mt-3
                      feedback-ss-container
                      d-flex
                      align-items-center
                      justify-content-center
                      mb-2
                    "
                  >
                    <div>Screenshot will be shown here</div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div></div>
      </div>
      <div
        class="
          pff-footer-container
          d-flex
          align-items-center
          justify-content-end
          pr-3
          bluebtn
        "
      >
        <b-button
          class="acs-cancelBtn-modal w-105px mr-3"
          @click="(discardSkill = false), gobackpointer()"
          >Cancel</b-button
        >
        <b-button
          class="acs-addBtn-modal w-105px"
          @click="(feedbackGiven = true), (discardSkill = false), submitForm()"
        >
          {{
            $route.name === "EditFeedbackform"
              ? "Update"
              : $route.name === "ActivateFeedbackForm"
              ? "Activate"
              : "Save"
          }}
        </b-button>
      </div>
    </div>
    <b-modal id="alert-modal">Hello From My Modal!</b-modal>
    <ConfirmModal
      @confirmButton="confirmButton"
      @handle-submit="saveForm"
      :button="button"
      :header="mobheader"
      :msg="msg"
      :imageSrc="require('../../assets/img/feedbackform/confirmIcon.svg')"
    />

    <NewPreviewFeedback :feedbackData="feedbackData" />
  </div>
</template>

<script>
import NewPreviewFeedback from "../../views/InterviewProcess/NewPreviewFeedback.vue";
import {
  addfeedbackform,
  getfeedbackforms,
  updatefeedbackform,
  getAiSuggestionsForFeedback,
} from "../../utils/apiFunctions";
import draggable from "vuedraggable";

import {
  required,
  maxLength,
  helpers,
  requiredIf,
} from "vuelidate/lib/validators";
import feedbackFormMixins from "../../views/InterviewProcess/feedbackFormMixins.js";

import toast from "../../components/mixin/toast";
import ConfirmModal from "../../views/InterviewProcess/ConfirmModal.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
export default {
  name: "Feedbackform",
  components: {
    Spinner,
    ConfirmModal,
    draggable,
    NewPreviewFeedback,
  },
  mixins: [toast, feedbackFormMixins],
  validations() {
    return {
      feedbackData: {
        name: {
          required,
          maxLength: maxLength(128),
          alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
        },
      },
      skillrating: {
        name: {
          required: requiredIf(function () {
            return this.feedbackData.skillratings.length == 0;
          }),
          maxLength: maxLength(128),
        },
      },
    };
  },

  computed: {
    hasChanges() {
      if (
        this.feedbackData.skillratings.length !==
          this.originalData.skills.length ||
        this.feedbackData.name !== this.originalData.name
      ) {
        return true;
      }

      for (let i = 0; i < this.feedbackData.skillratings.length; i++) {
        const feedbackSkill = this.feedbackData.skillratings[i];
        const originalSkill = this.originalData.skills[i];

        if (JSON.stringify(feedbackSkill) !== JSON.stringify(originalSkill)) {
          return true;
        }
      }

      return false;
    },
    errorsameskill() {
      const skillname = this.skillrating.name.toLowerCase();
      for (const i of this.feedbackData.skillratings) {
        const name = i.name.toLowerCase();

        if (
          (!this.editskill && skillname === name) ||
          (this.editskill && i.id !== this.editID && skillname === name)
        ) {
          return true;
        }
      }
      return false;
    },
    isFromJD() {
      return this.$route.query.redirectTo;
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    if (sessionStorage.getItem("isReloading") === "true") {
      sessionStorage.removeItem("isReloading");
      const redirectTo = this.$route.query.redirectTo;
      if (redirectTo) {
        this.goToJd();
      } else {
        this.$router.go(-1);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  async created() {
    try {
      if (this.$route.name == "Feedbackform") {
        this.shimmerLoader = true;
        await this.getAiSuggestions();
      } else {
        await this.getallfeedbackforms();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.shimmerLoader = false;
    }
  },

  methods: {
    resetSelectedSkill() {
      this.skillrating = {
        id: null,
        name: "",
        mandatory: false,
        markingType: this.skillrating.markingType,
        commentMode: false,
        editskill: false,
      };
      // this.aiEditSkill = false;
      this.editskill = false;
      this.feedbackData.skillratings.forEach((skill) => {
        if (skill.id === this.editID) {
          skill.editskill = false;
        }
      });
    },
    editOrUpdateOrDeleteSkill(action, skill) {
      if (action === "edit") {
        // this.aiEditSkill = false;
        this.feedbackData.skillratings.forEach((i) => {
          if (i.id !== skill.id) {
            i.editskill = false;
          }
        });
        skill.editskill = true;
        this.editID = skill.id;
        this.singleSkill = skill;
        this.skillrating.name = skill.name;
        this.skillrating.commentMode = skill.commentMode;
        this.skillrating.mandatory = skill.mandatory;
        this.editskill = true;
        this.previousSkillRating = { ...this.skillrating };
      } else if (action === "update") {
        const skillIndex = this.feedbackData.skillratings.findIndex(
          (s) => s.id === this.singleSkill.id
        );

        if (skillIndex !== -1) {
          this.feedbackData.skillratings[skillIndex] = {
            ...this.feedbackData.skillratings[skillIndex],
            name: this.skillrating.name,
            commentMode: this.skillrating.commentMode,
            mandatory: this.skillrating.mandatory,
          };
        }
        const hasChanges =
          this.skillrating.name !== this.previousSkillRating.name ||
          this.skillrating.commentMode !==
            this.previousSkillRating.commentMode ||
          this.skillrating.mandatory;

        if (hasChanges && this.aiLength != 0) {
          this.aiEditSkill = true;
        }
        this.resetSelectedSkill();
      } else if (action === "discard") {
        this.previousSkillRating.markingType = this.skillrating.markingType;
        if (this.editskill) {
          this.skillrating = { ...this.previousSkillRating };
        } else {
          this.resetSelectedSkill();
        }
        this.aiEditSkill = false;
      } else if (action === "delete") {
        this.feedbackData.skillratings.splice(skill, 1);
        this.aiEditSkill = true;
      }
    },
    handleBeforeUnload(event) {
      sessionStorage.setItem("isReloading", "true");
      const message = "Changes you made may not be saved.";
      event.returnValue = message;
    },

    async getallfeedbackforms() {
      this.LoaderStatus = true;

      const response = await getfeedbackforms(
        this.$route.params.type,
        this.$route.params.feedbackFormID
      );
      if (response.status == 200) {
        this.feedbackformdata = response.data.data;
        this.feedbackData.name = this.feedbackformdata.name;
        this.feedbackData.skillratings = this.feedbackformdata.skills;
        this.feedbackData.screenshot = this.feedbackformdata.screenshot;
        this.originalData = JSON.parse(JSON.stringify(this.feedbackformdata));

        this.feedbackData.skillratings.forEach((skill) => {
          skill.editskill = false;
          this.skillrating.markingType = skill.markingType;
          // this.skillrating.commentMode = skill.commentMode;
        });
        this.LoaderStatus = false;
      }
    },
    async getAiSuggestions() {
      this.feedbackData.name = this.$route.query.name;
      try {
        let payload = {
          name: this.$route.query.name,
          count: this.$route.query.count,
        };

        const res = await getAiSuggestionsForFeedback(payload);

        if (res.status === 200) {
          this.skillrating.markingType = "rating";

          this.aiLength = res.data.data.length;

          if (this.aiLength != 0) {
            this.shimmerLoader = false;
            this.feedbackData.skillratings = res.data.data;
          } else {
            for (let i = 0; i < this.$route.query.count; i++) {
              const skillName = `Skill ${i + 1}`;
              this.feedbackData.skillratings.push({
                id: this.feedbackData.skillratings.length + 1,
                name: skillName,
                markingType: "rating",
                mark: "",
                commentMode: true,
                comments: "",
                mandatory: false,
                editskill: false,
              });
              this.shimmerLoader = false;
            }
          }
        } else {
          this.shimmerLoader = false;
        }
      } catch (error) {
        console.error("Error in getAiSuggestions:", error);
        this.shimmerLoader = false;
      }
    },

    confirmButton(value) {
      this.discardSkill = value;
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const scrollContainer = document.getElementById("scrollTobottom");

        scrollContainer.scrollBy({
          top: 5000,
          behavior: "smooth",
        });
      });
    },

    //router go back
    gobackpointer() {
      if (
        (this.$route.name === "Feedbackform" &&
          (this.skillrating.name !== "" ||
            this.feedbackData.name !== "" ||
            this.skillrating.markingType != "" ||
            this.skillrating.commentMode ||
            this.skillrating.mandatory)) ||
        ((this.$route.name === "EditFeedbackform" ||
          this.$route.name === "ActivateFeedbackForm") &&
          this.hasChanges)
      ) {
        this.mobheader = "Discard Changes";
        this.button = "Discard";
        this.msg = "Are you sure you want to discard the data you entered?";
        this.$bvModal.show("confirmationmsg");
      } else if (this.$route.query.status == "interview") {
        this.$router.push({
          name: "CreateInterviewProcess",
          query: {
            ...this.$route.query,
          },
        });
      } else if (this.$route.query.status == "editInterview") {
        this.$router.push({
          name: `EditInterviewProcess`,
          params: {
            interviewProcessID: this.$route.query.interviewProcessID,
          },
          query: {
            type: this.$route.query.type,
            sort: this.$route.query.sort,
          },
        });
      } else if (this.$route.query.status == "activateInterview") {
        this.$router.push({
          name: `ActivateInterview`,
          params: {
            interviewProcessID: this.$route.query.interviewProcessID,
          },
          query: {
            type: this.$route.query.type,
            sort: this.$route.query.sort,
          },
        });
      } else if (
        this.$route.query.status === "previewFeedbackForm" ||
        this.$route.query.status === "feedbackForm"
      ) {
        this.$router.push({
          path: "/hiringprocess",
          query: {
            type: this.$route.query.type,
            sort: this.$route.query.sort,
            status: "feedbackForm",
          },
        });
      }
    },

    async saveForm() {
      this.feedbackData.skillratings = this.feedbackData.skillratings.map(
        (feed, index) => {
          feed.id = index + 1;
          return feed;
        }
      );
      let data = {
        name: this.feedbackData.name,
        skills: this.feedbackData.skillratings,
        screenshot: this.feedbackData.screenshot,
        feedbackFormID: this.feedbackformdata?.feedbackFormID || null,
        aiEditSkill: this.aiEditSkill,
      };
      this.feedbackData.skillratings.forEach((skill, index) => {
        skill.id = index + 1;
      });

      this.LoaderStatus = true;

      if (!this.discardSkill) {
        try {
          let response = {};
          if (this.$route.name === "Feedbackform") {
            response = await addfeedbackform(data);
          } else {
            response = await updatefeedbackform(data);
          }
          if (response.status === 200) {
            data.feedbackId = response.data.data.feedbackFormID;
            this.$store.commit("scheduleInterviewVUEX/saveFeedbackForm", data);

            if (this.$route.name === "Feedbackform") {
              this.successModal("Feedback form added successfully!");
            } else if (this.$route.name === "EditFeedbackform") {
              this.successModal("Feedback form updated successfully!");
            } else if (this.$route.name === "ActivateFeedbackForm") {
              this.successModal("Feedback form activated successfully!");
            }
            this.clearform();
            this.LoaderStatus = false;

            if (this.isFromJD) {
              this.goToJd(
                response.data.data.feedbackFormID,
                this.feedbackData.name
              );
            } else {
              this.goToFeedback();
            }
          } else if (response.status === 409) {
            let errorMessage = response.data.data.Detail;
            this.errorModal(`${errorMessage}`);
            this.LoaderStatus = false;
          } else {
            this.errorModal("Something went wrong! Try again.");
            this.LoaderStatus = false;
          }
        } catch (error) {
          this.errorModal("Failed! Adding feedback form.");
          this.LoaderStatus = false;
          console.error(`Failed! Adding: ${error.message}`);
        }
      } else {
        this.goToFeedback();
        this.LoaderStatus = false;
      }
    },
    goToJd(processID, processName) {
      const { wtype, wsort, itype, isort, pageType, customerName } =
        this.$route.query;
      this.$router.push({
        name: this.$route.query.redirectTo,
        query: {
          to: "interview",
          type: pageType,
          wsort,
          wtype,
          itype,
          isort,
          customerName,
          ...(processID ? { fbprocess: processID } : {}),
          ...(processName ? { processName: processName } : {}),
          ...(this.$route.query.jobID
            ? { jobID: this.$route.query.jobID }
            : {}),
        },
      });
    },
    goToFeedback() {
      const newQuery = { ...this.$route.query };
      if (this.feedbackGiven) {
        newQuery.status = "feedbackGiven";
      }
      if (this.isFromJD) {
        this.goToJd();
      } else if (this.$route.query.status === "interview") {
        this.$router.push({
          name: "CreateInterviewProcess",
          query: newQuery,
        });
      } else if (this.$route.query.status === "editInterview") {
        delete newQuery.status;
        if (this.feedbackGiven) {
          newQuery.status = "feedbackGiven";
        }
        this.$router.push({
          name: "EditInterviewProcess",
          params: {
            interviewProcessID: this.$route.query.interviewProcessID,
          },
          query: newQuery,
        });
      } else if (this.$route.query.status === "activateInterview") {
        delete newQuery.status;
        if (this.feedbackGiven) {
          newQuery.status = "feedbackGiven";
        }
        this.$router.push({
          name: "ActivateInterview",
          params: {
            interviewProcessID: this.$route.query.interviewProcessID,
          },
          query: newQuery,
        });
      } else if (
        this.$route.query.status === "previewFeedbackForm" ||
        this.$route.query.status === "feedbackForm"
      ) {
        this.$router.push({
          path: "/hiringprocess",
          query: {
            type: this.$route.query.type,
            sort: this.$route.query.sort,
            status: "feedbackForm",
          },
        });
      }
    },
    addskill() {
      this.$v.skillrating.name.$touch();
      if (this.errorsameskill && !this.editskill) {
        this.errorModal("Skill Name already exists");
      } else if (!this.$v.skillrating.name.maxLength) {
        this.errorModal(" Should not exceed 128 characters");
      }
      if (!this.$v.skillrating.name.$invalid && !this.errorsameskill) {
        this.feedbackData.skillratings.push({
          id: this.feedbackData.skillratings.length + 1,
          name: this.skillrating.name,
          markingType: this.skillrating.markingType,
          mark: "",
          commentMode: this.skillrating.commentMode,
          comments: "",
          mandatory: this.skillrating.mandatory,
          editskill: this.editskill,
        });
        this.aiEditSkill = true;
        this.resetSelectedSkill();

        this.editskill = false;
      }

      this.scrollToBottom();
    },
    async submitForm() {
      this.$v.$touch();
      this.skillEval =
        !this.skillrating.commentMode &&
        this.skillrating.markingType === "" &&
        this.feedbackData.skillratings.length === 0;
      if (this.skillEval == true || this.feedbackData.name === "") {
        this.errorModal("Please fill the mandatory fields!");
        return;
      }

      if (
        !this.$v.feedbackData.name.maxLength ||
        !this.$v.skillrating.name.maxLength
      ) {
        this.errorModal("Should not exceed 128 characters");
        return;
      }

      if (this.errorsameskill) {
        this.errorModal("Skill Name already exists");
        return;
      }

      if (
        (this.feedbackData.name !== "" &&
          this.feedbackData.skillratings.length === 0 &&
          this.skillrating.name != "") ||
        (this.feedbackData.name !== "" &&
          this.feedbackData.skillratings.length === 1 &&
          this.skillrating.name != "" &&
          this.feedbackData.skillratings[this.edit].editskill) ||
        this.feedbackData.skillratings.length === 0
      ) {
        this.errorModal("At least one skill has to be added");
        this.addedskill = true;
      } else if (
        this.feedbackData.name !== "" &&
        this.$v.skillrating.name !== "" &&
        this.feedbackData.skillratings.length > 0
      ) {
        this.addedskill = false;
      }

      if (
        this.feedbackData.name !== "" &&
        this.feedbackData.skillratings.length > 0
      ) {
        if (!this.$v.$invalid && !this.errorsameskill && !this.addedskill) {
          this.$v.$reset();
          if (this.skillrating.name != "" && this.skillrating.name != null) {
            this.button = "Continue";
            this.msg = "";
            this.mobheader =
              "You have some unsaved changes, Do you like to continue without saving ?";
            this.$bvModal.show("confirmationmsg");
          } else {
            this.saveForm();
          }
        }
      }
    },
  },
};
</script>

<style>
.h-55px {
  height: 55px;
}
.feedback-left-container .custom-control-label::before {
  position: absolute;
  top: 2px;
  left: -1.5rem;
  display: block;
  width: 15px;
  height: 15px;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #adb5bd solid 1px;
}
.feedback-left-container .custom-control-label::after {
  top: 1px;
}
.fdbck-recodn-container {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 4px 4px;
  padding: 25px;
}
.interskilkls-head {
  font-weight: 600;
  font-size: 13px;
  color: #72738e;
  word-break: break-all;
}
.interskills-container {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 10px;
}
.highlighted-interskills-container {
  background: #ffffff;
  border: 2px solid #bebebe;
  border-radius: 8px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.fdbck-right-head-container {
  padding: 10px 15px;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  margin: 5px;
  background: rgba(10, 86, 200, 0.5);
  border-radius: 2px;
}
.fdbck-right-detail-container {
  background: #ffffff;
  border: 0.7px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 1px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  height: calc(100vh - 150px);
  overflow: auto;
}
.feed-heading {
  font-weight: 600;
  font-size: 14px;
  color: #696969;
}
.feedbackform-inputs {
  padding: 15px;
  background: #ffffff;
  border: 1px solid #72738e;
  box-sizing: border-box;
  border-radius: 5px;
}
.feedback-height {
  height: calc(100vh - 150px);
}
.feedback-left-container {
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  width: 50%;
}

.feedback-right-main-container {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  width: 50%;
}
.schreenshot-div {
  height: 200px;
}
.right-sub-ed {
  height: 92%;
  overflow: auto;
}
.no-skills-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #696969;
}

.schreenshotdiv-file {
  opacity: 0;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
<style scoped>
.b-rating.disabled {
  background-color: white;
}
.ip-opacity {
  opacity: 0.5;
}
</style>
